type ClassValue = string | false | null | undefined

/** Minimal class-name joiner. Avoids a dependency for ~5 lines of work. */
export function cx(...values: ClassValue[]): string {
  let out = ''
  for (const v of values) {
    if (typeof v === 'string' && v.length > 0) out += out.length > 0 ? ` ${v}` : v
  }
  return out
}
